import { TextField } from "@mui/material";
import {InputAdornment , IconButton} from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import '../EnrollmentForm/NewEnrollmentForm.css';

const SSNTextField = ({ name, onChange, showSSN, setFocus, handleClickShowSSN, handleOnBlur, formErrors, value, field, editable}) => {
    const readOnly = editable==="No"? true: false;
   return(
    <>
    {readOnly ?
    <>
    <TextField 
        type={showSSN? "text": "password"} 
        id="enrollmentSSN"
        className={field==="enrollment"?"number-input":""}
        variant="outlined" 
        margin="none" 
        label="" 
        placeholder="SSN" 
        onChange={onChange}
        value={value} 
        name={name}  
        sx={{ width: "190px" }}
        InputProps={{ 
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowSSN}
                        edge="end"
                    >
                        {showSSN ? <VisibilityOff  /> : <Visibility  />}
                    </IconButton>
                </InputAdornment>
                )}}
        inputProps={{ readOnly:true, maxLength:9}}
        onFocus={ () => setFocus(true)}
        onBlur={handleOnBlur}
        helperText={formErrors && formErrors.SSN ? formErrors.SSN:""} error={formErrors? formErrors.err_SSN : ""}></TextField>
        </>
        :
        <>
        <TextField 
        type={showSSN? "text": "password"} 
        id="enrollmentSSN"
        className={field==="enrollment"?"number-input":""}
        variant="outlined" 
        margin="none" 
        label="" 
        placeholder="SSN"
        onChange={onChange}
        value={value} 
        name={name}  
        sx={{ width: "190px" }}
        InputProps={{ 
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowSSN}
                        edge="end"
                    >
                        {showSSN ? <VisibilityOff  /> : <Visibility  />}
                    </IconButton>
                </InputAdornment>
                )}}
        inputProps={{ maxLength:9}}
        onFocus={ () => setFocus(true)}
        onBlur={handleOnBlur}
        error={formErrors && formErrors.err_SSN ? formErrors.err_SSN:""} 
        helperText={formErrors && formErrors.SSN_helperText ? formErrors.SSN_helperText :""} ></TextField>
        </>}
        </>
   );
}

export default SSNTextField;